<template>
  <el-main>
    <!-- data1 sort btn -->
    <el-button v-if="!data1.sort.status" @click="data1OpenSortFunction()">排序</el-button>
    <el-button v-if="data1.sort.status" @click="data1SubmitSort()">確定</el-button>
    <el-button v-if="data1.sort.status" @click="data1CloseSortFunction()">取消</el-button>
    <!-- data1 add btn -->
    <el-button type="primary" v-if="!data1.sort.status" @click="data1.addForm1.dialogVisible = true">+ 商品</el-button>
    <!-- 間隔 -->
    <br /><br />
    <!-- data1 table -->
    <el-table :data="data1.data" style="width: 100%">
      <el-table-column label="編號">
        <template slot-scope="scope">
          <div v-if="data1.sort.status">
            <el-button v-if="scope.$index !== 0" icon="el-icon-top" @click="data1SortUpdateIndex(scope.$index, scope.$index - 1)"></el-button>
            <el-button
              v-if="scope.$index !== data1.data.length - 1"
              icon="el-icon-bottom"
              @click="data1SortUpdateIndex(scope.$index, scope.$index + 1)"
            ></el-button>
          </div>
          <div v-if="!data1.sort.status">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="名稱">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="簡介">
        <template slot-scope="scope">
          <ul>
            <li v-for="(item, index) in scope.row.introduces" :key="index">{{ item }}</li>
          </ul>
          <!-- {{scope.row.introduceHtml}} -->
        </template>
      </el-table-column>
      <el-table-column label="封面照片">
        <template slot-scope="scope">
          <el-image fit="contain" style="width: 130px; height: 130px" :src="scope.row.pictureUrl" :preview-src-list="[scope.row.pictureUrl]"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="附件">
        <template slot-scope="scope">
          <el-link :href="scope.row.attachmentFileUrl" target="_blank">{{ scope.row.attachmentFileName }}</el-link>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <div v-if="!data1.sort.status">
            <el-button @click="data1UpdateForm1DialogOpen(scope.$index)">編輯</el-button>
            <el-button @click="data1Delete(scope.$index)">刪除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- data1 add dialog -->
    <el-dialog title="新增" :visible.sync="data1.addForm1.dialogVisible" width="30%" @closed="data1AddForm1DialogClosed()" :close-on-click-modal="false">
      <el-form
        :model="data1.addForm1.data"
        status-icon
        :rules="data1.addForm1.rules"
        ref="data1AddForm1"
        label-width="100px"
        class="demo-ruleForm"
        v-loading.lock="data1.addForm1.loading"
      >
        <el-form-item label="名稱" prop="name">
          <el-input type="text" v-model.trim="data1.addForm1.data.name" autocomplete="off" maxlength="60" show-word-limit></el-input>
        </el-form-item>
        <el-form-item
          v-for="(introduce, index) in data1.addForm1.data.introduces"
          :label="'簡介' + (index + 1)"
          :key="introduce.key"
          :prop="'introduces.' + index + '.value'"
          :rules="[{ required: true, message: '簡介不得為空', trigger: 'blur' }]"
        >
          <el-input v-model="introduce.value"></el-input><el-button @click.prevent="data1AddForm1RemoveIntroduceItem(introduce)">删除</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="data1AddForm1AddIntroduceItem">新增簡介</el-button>
        </el-form-item>
        <el-form-item label="封面照片" prop="picture">
          <PictureUploader :fileQuantityLimit="1" :fileList.sync="data1.addForm1.data.picture" pictureSizeRemark="寬700px & 高700px"></PictureUploader>
        </el-form-item>
        <el-form-item label="附件" prop="attachmentFile">
          <AttachmentFileUploader :fileQuantityLimit="1" :fileList.sync="data1.addForm1.data.attachmentFile"></AttachmentFileUploader>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-alert v-show="data1.addForm1.errorMessage.length > 0" type="error" :closable="false">{{ data1.addForm1.errorMessage }} </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.addForm1.dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="data1AddForm1Submit()">送出</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- data1 update dialog -->
    <el-dialog title="編輯" :visible.sync="data1.updateForm1.dialogVisible" width="30%" @closed="data1UpdateForm1DialogClosed()" :close-on-click-modal="false">
      <el-form
        :model="data1.updateForm1.data"
        status-icon
        :rules="data1.updateForm1.rules"
        ref="data1UpdateForm1"
        label-width="100px"
        class="demo-ruleForm"
        v-loading.lock="data1.updateForm1.loading"
      >
        <el-form-item label="名稱" prop="name">
          <el-input type="text" v-model.trim="data1.updateForm1.data.name" autocomplete="off" maxlength="60" show-word-limit></el-input>
        </el-form-item>
        <el-form-item
          v-for="(introduce, index) in data1.updateForm1.data.introduces"
          :label="'簡介' + (index + 1)"
          :key="introduce.key"
          :prop="'introduces.' + index + '.value'"
          :rules="[{ required: true, message: '簡介不得為空', trigger: 'blur' }]"
        >
          <el-input v-model="introduce.value"></el-input><el-button @click.prevent="data1UpdateForm1RemoveIntroduceItem(introduce)">删除</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="data1UpdateForm1AddIntroduceItem">新增簡介</el-button>
        </el-form-item>
        <el-form-item label="封面照片" prop="picture">
          <PictureUploader :fileQuantityLimit="1" :fileList.sync="data1.updateForm1.data.picture" pictureSizeRemark="寬700px & 高700px"></PictureUploader>
        </el-form-item>
        <el-form-item label="附件" prop="attachmentFile">
          <AttachmentFileUploader :fileQuantityLimit="1" :fileList.sync="data1.updateForm1.data.attachmentFile"></AttachmentFileUploader>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-alert v-show="data1.updateForm1.errorMessage.length > 0" type="error" :closable="false">{{ data1.updateForm1.errorMessage }} </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.updateForm1.dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="data1UpdateForm1Submit()">送出</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-main>
</template>

<script>
import { B_TrainingSystem_Add, B_TrainingSystem_GetList, B_TrainingSystem_Update, B_TrainingSystem_Delete, B_TrainingSystem_Sort } from "@/assets/js/api";
import PictureUploader from "@/components/PictureUploader.vue";
import AttachmentFileUploader from "@/components/AttachmentFileUploader.vue";

export default {
  data() {
    return {
      trainingSystemCategorys: {
        basic: { id: 1, name: "基本培訓" },
        professional: { id: 2, name: "專業行銷" },
        video: { id: 3, name: "視訊直播教學" },
      },
      nowTrainingSystemCategoryId: "",
      data1: {
        data: [],
        addForm1: {
          dialogVisible: false,
          loading: false,
          formRef: "data1AddForm1",
          errorMessage: "",
          data: {
            name: "",
            picture: [],
            attachmentFile: [],
            introduces: [],
          },
          rules: {
            name: [
              { required: true, message: "請輸入名稱" },
              { min: 1, max: 60, message: "名稱必須在60個字元內" },
            ],
            picture: [{ required: true, message: "請上傳檔案" }],
            attachmentFile: [{ required: false, message: "請上傳檔案" }],
          },
        },
        updateForm1: {
          updateId: 0,
          dialogVisible: false,
          loading: false,
          formRef: "data1UpdateForm1",
          errorMessage: "",
          data: {
            name: "",
            introduces: [],
            picture: [],
            attachmentFile: [],
          },
          rules: {
            name: [
              { required: true, message: "請輸入名稱" },
              { min: 1, max: 60, message: "名稱必須在60個字元內" },
            ],
            picture: [{ required: true, message: "請上傳檔案" }],
            // attachmentFile: [{ required: true, message: "請上傳檔案" }],
          },
        },
        sort: {
          status: false,
          originalDataTemp: [], // 開始更新時先保留原始資料
        },
      },
    };
  },
  components: {
    AttachmentFileUploader,
    PictureUploader,
  },
  mounted() {
    // this.data1GetList();
    this.initialTrainingSystemCategory();
  },
  watch: {
    $route() {
      // 共用原件的頁面 需手動重新載入資料
      this.$data.data1 = this.$options.data().data1;
      this.initialTrainingSystemCategory();
    },
    nowTrainingSystemCategoryId() {
      this.data1GetList();
    },
  },
  methods: {
    initialTrainingSystemCategory() {
      // 初始化商品列表
      const pathStr = this.$route.path;
      const thisPageName = pathStr.substring(pathStr.lastIndexOf("/") + 1);
      this.nowTrainingSystemCategoryId = this.trainingSystemCategorys[thisPageName].id;

      this.data1GetList();
    },
    // data1 get list
    data1GetList() {
      B_TrainingSystem_GetList(this.nowTrainingSystemCategoryId)
        .then((res) => {
          this.data1.data = res.data.data;
        })
        .catch((err) => {
          this.$notify.error({
            title: "錯誤",
            message: err.response.data.message,
          });
        });
    },
    // data1 add
    data1AddForm1DialogClosed() {
      this.data1.addForm1.loading = false;
      this.$refs[this.data1.addForm1.formRef].resetFields();
      this.data1.addForm1.errorMessage = "";
      this.data1.addForm1.data.introduces = []; // resetFields不會將陣列項目歸0
    },
    data1AddForm1Submit() {
      this.$refs[this.data1.addForm1.formRef].validate((valid) => {
        if (valid) {
          this.data1.addForm1.loading = true;
          this.data1.addForm1.errorMessage = "";
          const fd = new FormData();
          fd.append("name", this.data1.addForm1.data.name);
          const introducesArray = [];
          this.data1.addForm1.data.introduces.forEach((introduce) => {
            introducesArray.push(introduce.value);
          });
          fd.append("introducesJsonStr", JSON.stringify(introducesArray));
          fd.append("categoryId", this.nowTrainingSystemCategoryId);
          fd.append("picture", this.data1.addForm1.data.picture[0].raw);

          if (this.data1.addForm1.data.attachmentFile && this.data1.addForm1.data.attachmentFile.length > 0) {
            fd.append("attachmentFile", this.data1.addForm1.data.attachmentFile[0].raw);
          }

          fd.append("introduces", this.data1.addForm1.data.introduces);

          B_TrainingSystem_Add(fd)
            .then(() => {
              this.$notify({
                title: "成功",
                message: "新增成功",
                type: "success",
              });
              this.data1.addForm1.dialogVisible = false;
              this.data1GetList();
            })
            .catch((err) => {
              this.data1.addForm1.loading = false;
              this.data1.addForm1.errorMessage = err.response.data.message;
            });
        }
      });
    },
    // data1 update
    data1UpdateForm1DialogOpen(index) {
      const thisData = this.data1.data[index];
      this.data1.updateForm1.updateId = this.data1.data[index].id;
      this.data1.updateForm1.dialogVisible = true;
      this.data1.updateForm1.data.name = thisData.name;
      if (thisData.introduces !== null) {
        thisData.introduces.forEach((introduce, i) => {
          this.data1.updateForm1.data.introduces.push({
            value: introduce,
            key: `Date.now()${i}`,
          });
        });
      }

      this.data1.updateForm1.data.picture = [
        {
          url: thisData.pictureUrl,
          originalFile: true,
        },
      ];
      this.data1.updateForm1.data.attachmentFile = [
        {
          name: thisData.attachmentFileName,
          originalFile: true,
        },
      ];
    },
    data1UpdateForm1DialogClosed() {
      this.data1.updateForm1.loading = false;
      this.$refs[this.data1.updateForm1.formRef].resetFields();
      this.data1.updateForm1.updateId = 0;
      this.data1.updateForm1.errorMessage = "";
      this.data1.updateForm1.data.introduces = []; // resetFields不會將陣列項目歸0
    },
    data1UpdateForm1Submit() {
      this.$refs[this.data1.updateForm1.formRef].validate((valid) => {
        if (valid) {
          this.data1.updateForm1.errorMessage = "";
          this.data1.updateForm1.loading = true;
          const fd = new FormData();
          const checkPicture = this.data1.updateForm1.data.picture[0].originalFile !== true;
          if (checkPicture) {
            fd.append("picture", this.data1.updateForm1.data.picture[0].raw);
          }
          console.log(this.data1.updateForm1.data.picture);
          const attachmentFileArr = this.data1.updateForm1.data.attachmentFile;

          if (attachmentFileArr.length > 0 && attachmentFileArr[0].originalFile !== true) {
            fd.append("attachmentFile", attachmentFileArr[0].raw);
          } else {
            // 明確告知後端：使用者已將檔案刪除，不再上傳
            fd.append("attachmentFile", ""); // 或者用 null、空字串等視後端 API 接受方式而定
          }
          fd.append("isAttachmentDeleted", this.data1.updateForm1.data.attachmentFile.length === 0 ? "true" : "false");

          fd.append("name", this.data1.updateForm1.data.name);
          const introducesArray = [];
          this.data1.updateForm1.data.introduces.forEach((introduce) => {
            introducesArray.push(introduce.value);
          });
          fd.append("introducesJsonStr", JSON.stringify(introducesArray));

          B_TrainingSystem_Update(this.data1.updateForm1.updateId, fd)
            .then(() => {
              this.$notify({
                title: "成功",
                message: "修改成功",
                type: "success",
              });
              this.data1.updateForm1.dialogVisible = false;
              this.data1GetList();
            })
            .catch((err) => {
              this.data1.updateForm1.loading = false;
              this.data1.updateForm1.errorMessage = err.response.data.message;
            });
        }
      });
    },
    // data1 delete
    data1Delete(index) {
      this.$confirm("確定刪除?", "確認", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          B_TrainingSystem_Delete(this.data1.data[index].id)
            .then(() => {
              this.$notify({
                title: "成功",
                message: "刪除成功",
                type: "success",
              });
              this.data1GetList();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "warning",
              });
            });
        })
        .catch(() => {});
    },
    // data1 sort
    data1OpenSortFunction() {
      this.data1.sort.status = true;
      this.data1.sort.originalDataTemp = [...this.data1.data]; // 暫存原本資料
    },
    data1CloseSortFunction() {
      this.data1.sort.status = false;
      this.data1.data = [];
      this.data1.data = [...this.data1.sort.originalDataTemp]; // 回復原本資料
    },
    data1SortUpdateIndex(originalIndex, newIndex) {
      [this.data1.data[originalIndex], this.data1.data[newIndex]] = [this.data1.data[newIndex], this.data1.data[originalIndex]];
      const temp = this.data1.data;
      this.data1.data = [];
      this.data1.data = temp;
    },
    data1SubmitSort() {
      const sortList = [];

      this.data1.data.forEach((item, index) => {
        sortList.push({
          id: item.id,
          sortNumber: index,
        });
      });

      B_TrainingSystem_Sort(sortList)
        .then(() => {
          this.$notify({
            title: "成功",
            message: "修改成功",
            type: "success",
          });
          this.data1.sort.status = false;
          this.data1GetList();
        })
        .catch((err) => {
          this.$message({
            message: err.response.data.message,
            type: "warning",
          });
        });
    },

    data1AddForm1RemoveIntroduceItem(item) {
      const index = this.data1.addForm1.data.introduces.indexOf(item);
      if (index !== -1) {
        this.data1.addForm1.data.introduces.splice(index, 1);
      }
    },
    data1AddForm1AddIntroduceItem() {
      this.data1.addForm1.data.introduces.push({
        value: "",
        key: Date.now(),
      });
    },

    data1UpdateForm1RemoveIntroduceItem(item) {
      const index = this.data1.updateForm1.data.introduces.indexOf(item);
      if (index !== -1) {
        this.data1.updateForm1.data.introduces.splice(index, 1);
      }
    },
    data1UpdateForm1AddIntroduceItem() {
      this.data1.updateForm1.data.introduces.push({
        value: "",
        key: Date.now(),
      });
    },
  },
};
</script>
